/**
 * Created by CCristi on 4/4/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractImplementation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let AbstractImplementation = exports.AbstractImplementation = function (_Core$OOP$Interface) {
  _inherits(AbstractImplementation, _Core$OOP$Interface);

  /**
   * @param {IdentityProvider} identityProvider
   */
  function AbstractImplementation(identityProvider) {
    _classCallCheck(this, AbstractImplementation);

    // @todo: add other methods such as `normalizeMetadata`

    var _this = _possibleConstructorReturn(this, (AbstractImplementation.__proto__ || Object.getPrototypeOf(AbstractImplementation)).call(this, ['refreshIdentity']));

    _this._identityProvider = identityProvider;
    return _this;
  }

  /**
   * @returns {String}
   */


  _createClass(AbstractImplementation, [{
    key: 'refreshToken',
    get: function get() {
      return this._identityProvider.refreshToken;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'clientName',
    get: function get() {
      return this._identityProvider.clientName;
    }

    /**
     * @returns {IdentityProvider|*}
     */

  }, {
    key: 'identityProvider',
    get: function get() {
      return this._identityProvider;
    }
  }]);

  return AbstractImplementation;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/IdentityImplementation/AbstractImplementation.js
// module id = 446
// module chunks = 0